export const QUARTER = '3 mons';
export const MONTH = '1 mon';
export const DAY = '1 day';
export const WEEK = '7 days';
export const BIWEEK = '14 days';

export const labels = {
  [QUARTER]: 'quarterly',
  [MONTH]: 'monthly',
  [WEEK]: 'weekly',
  [BIWEEK]: 'bi-weekly',
  [DAY]: 'daily',
};
